import { Div, Collection } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { TextWithPictureField } from "../../../Models/Description/TextWithPicture/TextWithPictureField";
import { TextWithPicturePrinterV2 } from "../TextWithPicture/TextWithPicturePrinter";
import { FieldType } from "../../../Models/Description/FieldType";
import { NormalizeUrl } from "../NormalizeUrl";


export class DescriptionPrinterForPage extends Div
{
    constructor(fields: Collection<Field>)
    {
        super();

        this.Append(
            ...fields.Items
                .filter(entry => entry.Visible.value)
                .filter(entry => entry.Type === FieldType.TextWithPicture)
                .map(entry => new TextWithPicturePrinterV2(entry.Header.value, entry as TextWithPictureField)
                    .Id(NormalizeUrl.Normalize(entry.Header.value)))
        );
    }
}
